export const ATLAS_BTN_PRIMARY =
  "rounded-lg px-4 py-2 text-sm font-medium uppercase text-white transition-colors whitespace-nowrap bg-sidebar-active hover:bg-red-600";

export const ATLAS_BTN_SECONDARY =
  "rounded-lg border border-border px-4 py-2 text-sm font-medium uppercase transition-colors whitespace-nowrap text-muted-foreground hover:bg-secondary";

export const ATLAS_MENU_ITEM =
  "flex w-full min-h-[40px] items-center rounded-md px-3 py-2.5 text-left text-sm font-medium uppercase leading-normal text-gray-700 hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed";

export const ATLAS_MENU_ITEM_DANGER =
  "flex w-full min-h-[40px] items-center rounded-md px-3 py-2.5 text-left text-sm font-medium uppercase leading-normal text-[#DC1F00] hover:bg-red-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed";

/** Toolbar/action buttons display labels in ALL CAPS regardless of source casing. */
export function formatButtonLabel(value) {
  if (typeof value !== "string" || !value) return value;
  return /[a-zA-Z]/.test(value) ? value.toUpperCase() : value;
}

/** Section tab labels display in ALL CAPS regardless of source casing. */
export function formatTabLabel(value) {
  return formatButtonLabel(value);
}
